import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as hotelActions from './../../../../../actions/hotelAction';
import * as locationActions from './../../../../../actions/locationAction';
import { uploadAction } from './../../../../../actions/uploadAction';
import { getListProvinces } from './../../../../../actions/generalAction';
import * as amenityActions from './../../../../../actions/amenityAction';
import HotelDetail from './HotelDetail';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        uploadState: state.uploadReducer,
        generalState: state.generalReducer,
        locationState: state.locationReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
        setHotelDetail: (hotel) => dispatch(hotelActions.setHotelDetail(hotel)),
        updateHotelDetail: (hotel) => dispatch(hotelActions.updateHotelDetail(hotel)),
        createHotelDetail: (hotel, callbacks) => dispatch(hotelActions.createHotelDetail(hotel, callbacks)),
        getListLocations: (filters) => dispatch(locationActions.getListLocations(filters)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
        getProvinces: () => dispatch(getListProvinces()),
        createHotelTranslate: (hotel, language) => dispatch(hotelActions.createHotelTranslate(hotel, language)),
        updateHotelTranslate: (hotel, language) => dispatch(hotelActions.updateHotelTranslate(hotel, language)),
        deleteHotelTranslate: (hotel, refreshParams) => dispatch(hotelActions.deleteHotelTranslate(hotel, refreshParams)),
        getTagGroupDetailSku: (id) => dispatch(hotelActions.getTagGroupDetailSku(id)),
        setTagGroupDetailSku: (data) => dispatch(hotelActions.setTagGroupDetailSku(data)),
        updateTagGroupDetailSkuActive: (tagsGroup, id) => dispatch(hotelActions.updateTagGroupDetailSkuActive(tagsGroup, id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HotelDetail));
